import { render, staticRenderFns } from "./Bird.vue?vue&type=template&id=402fc68c"
import script from "./Bird.vue?vue&type=script&lang=js"
export * from "./Bird.vue?vue&type=script&lang=js"
import style0 from "./Bird.vue?vue&type=style&index=0&id=402fc68c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports